const MainTitle = props => {
  return (
    <h1 className={`fw-bold ${props.className}`} >{props.children}</h1>
  );
}

export default MainTitle;
